import { createContext, useContext } from 'react';

const TripAccessContext = createContext({ role: null, legacy: false });

export function useTripAccess() {
  return useContext(TripAccessContext);
}

export default TripAccessContext;
